<template>
  <div class="tabbar1">
    <!-- 头部轮播图模块========================== -->
    <header class="slider-wrapper">
      <div class="input">
        <span class="s1" @click="no1()">
          <van-icon name="wap-nav" color="#fff" />
          <van-popup
            v-model="show2"
            get-container="body"
            position="left"
            :style="{ height: '100%' ,width:'45%'}"
          >
            <h5 style=" width: 90%;
             margin: 1rem auto;">这个开发者比较懒，什么内容有没有写~</h5>
            <img style="width:100%" src="~@/assets/images/表情包.png" alt />
          </van-popup>
        </span>
        <div class="in">
          <div class="logo">
            <span></span>
            <span>
              <van-icon name="search" />
            </span>
            <span></span>
          </div>
          <input type="text" placeholder="搜索" />
        </div>
        <span class="s2" @click="no()">
          <van-icon name="contact" color="#fff" />
        </span>
        <!-- <van-search shape="round" background="#c82519" placeholder="请输入搜索关键词" /> -->
      </div>
      <div class="bg"></div>
      <div class="swi">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <a :href="swi.url1">
              <img :src="swi.img1" alt />
            </a>
          </van-swipe-item>
          <van-swipe-item>
            <a :href="swi.url2">
              <img :src="swi.img2" alt />
            </a>
          </van-swipe-item>
          <van-swipe-item>
            <a :href="swi.url3">
              <img :src="swi.img3" alt />
            </a>
          </van-swipe-item>
          <van-swipe-item>
            <a :href="swi.url4">
              <img :src="swi.img4" alt />
            </a>
          </van-swipe-item>
          <van-swipe-item>
            <a :href="swi.url5">
              <img :src="swi.img5" alt />
            </a>
          </van-swipe-item>
          <van-swipe-item>
            <a :href="swi.url6">
              <img :src="swi.img6" alt />
            </a>
          </van-swipe-item>
        </van-swipe>
      </div>
    </header>
    <!-- 领券模块================================ -->
    <div class="floor">
      <div class="floor_left">
        <a :href="floor.url1">
          <img v-lazy="floor.img1" alt />
        </a>
        <span>现货预售</span>
      </div>
      <div class="floor_conter">
        <a :href="floor.url2">
          <img v-lazy="floor.img2" alt />
        </a>
        <a :href="floor.url3">
          <img v-lazy="floor.img3" alt />
        </a>
      </div>
      <div class="floor_right">
        <a :href="floor.url4">
          <img v-lazy="floor.img4" alt />
        </a>
        <span>好书预售</span>
      </div>
    </div>
    <!-- 分类模块================================ -->
    <div class="classify">
      <van-swipe class="my-swipe" indicator-color="white">
        <van-swipe-item class="df">
          <div v-for="(item, index) in fl1" :key="index" class="div">
            <a :href="item.url">
              <img v-lazy="item.img" loading="@/assets/logo.png" />
            </a>
            <span>{{ item.num }}</span>
          </div>
        </van-swipe-item>
        <van-swipe-item class="df">
          <div v-for="(item, index) in fl2" :key="index" class="div">
            <a :href="item.url">
              <img v-lazy="item.img" alt />
            </a>
            <span>{{ item.num }}</span>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 秒杀倒计时模块========================== -->
    <div class="seckill">
      <div class="seckill_box">
        <div class="seckill_box_up">
          <div class="seckill_box_up_left">
            <div class="d1">京东秒杀</div>
            <div class="d2">10</div>
            <div class="d3">
              <van-count-down :time="10800000">
                <template #default="timeData">
                  <span class="block">{{ timeData.hours }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ timeData.minutes }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ timeData.seconds }}</span>
                </template>
              </van-count-down>
            </div>
          </div>
          <div class="seckill_box_up_right">
            <a href="https://wqs.jd.com/portal/wx/seckill_m/index.shtml?st=1">更多秒杀</a>
            <a href="https://wqs.jd.com/portal/wx/seckill_m/index.shtml?st=1"></a>
          </div>
        </div>
        <div class="seckill_box_below">
          <div class="seckill_box_below_box">
            <div v-for="(item, index) in ms" :key="index">
              <a :href="item.url">
                <img v-lazy="item.img" alt />
              </a>
              <span>
                <p>{{ item.num1 }}</p>
                <p>{{ item.num2 }}</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 精选商品模块============================ -->
    <div class="jx">
      <div v-for="(item, index) in jx" :key="index" class="div">
        <a :href="item.url">
          <img :src="item.img" alt />
        </a>
        <p class="p1">{{ item.num1 }}</p>
        <p class="p2">{{ item.num2 }}</p>
      </div>
    </div>
    <!-- 热卖模块================================ -->
    <div class="rm">
      <div class="rm_box_left">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" height="100px">
          <van-swipe-item>
            <img :src="dxx1.img1" alt />
          </van-swipe-item>
          <van-swipe-item>
            <img :src="dxx1.img2" alt />
          </van-swipe-item>
          <van-swipe-item>
            <img :src="dxx1.img3" alt />
          </van-swipe-item>
          <van-swipe-item>
            <img :src="dxx1.img4" alt />
          </van-swipe-item>
          <van-swipe-item>
            <img :src="dxx1.img5" alt />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="rm_box_right">
        <div class="rm_box_right_up1">
          <div class="rm_box_right_up">
            <span>海尔家电</span>
            <p>科技领先海尔智慧家电</p>
          </div>
          <div class="rm_box_right_below1">
            <img
              src="//m.360buyimg.com/mobilecms/s150x150_jfs/t1/166459/23/7113/89855/602e4a1dE60ca1b25/b535a64adf1ffa7f.jpg!q70.jpg.dpg"
              alt
            />
            <img
              src="//m.360buyimg.com/mobilecms/s150x150_jfs/t1/191797/7/3981/41404/60a4d128E1f52a683/4cc63569fdbe423d.jpg!q70.jpg.dpg"
              alt
            />
          </div>
        </div>
        <div class="rm_box_right_up1">
          <div class="rm_box_right_up">
            <span>完美纪念</span>
            <p>过生日要有仪式感</p>
          </div>
          <div class="rm_box_right_below1">
            <img
              src="//m.360buyimg.com/mobilecms/s150x150_jfs/t14251/176/2258904398/450102/523e9427/5a90d11fNf560bd5d.jpg!q70.jpg.dpg"
              alt
            />
            <img
              src="//m.360buyimg.com/mobilecms/s150x150_jfs/t1/155792/39/7574/99218/600e902dE2c8770d8/37f8a0f745147491.jpg!q70.jpg.dpg"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 商品展示模块=========================== -->
    <div class="sp">
      <div class="sp_box" v-for="(item, index) in sp" :key="index">
        <div class="sp_left">
          <div class="d1">
            <van-image :src="item.img1" lazy-load class="img" @click="cyl(item.url1)" />
          </div>
          <div class="s1">{{ item.num1 }}</div>
          <p class="p1">￥{{ item.num2 }}</p>
          <div class="d2">
            <span>自营</span>
            <span>放心购</span>
            <span>看相似</span>
          </div>
          <p class="p2">{{ item.num3 }}</p>
        </div>
        <div class="sp_left">
          <div class="d1">
            <van-image :src="item.img2" lazy-load class="img" @click="cyl(item.url2)" />
          </div>
          <div class="s1">{{ item.num4 }}</div>
          <p class="p1">￥{{ item.num5 }}</p>
          <div class="d2">
            <span>自营</span>
            <span>放心购</span>
            <span>看相似</span>
          </div>
          <p class="p2">{{ item.num6 }}</p>
        </div>
      </div>
    </div>
    <div class="dibu">没有更多了.....</div>
    <!-- tab===================================== -->
    <div class="tab"></div>
  </div>
</template>
<script>
import data from "@/data/tabbar1_data.js";
// const show1 = () => import("@/components/show/show1.vue");
export default {
  name: "tabbar1",
  components: {
    // 组件注册
    // show1
  },
  data() {
    return {
      swi: data.data.swi,
      floor: data.data.floor,
      fl1: data.data.fl1,
      fl2: data.data.fl2,
      ms: data.data.ms,
      jx: data.data.jx,
      dxx1: data.data.dxx1,
      sp: data.data.sp,
      show2: false
    };
  },
  methods: {
    no() {
      alert("该模块还没开发呢，别点了！！！");
    },
    no1() {
      this.show2 = !this.show2;
    },
    cyl(url) {
      this.$router.push(url);
    },
    go(url) {
      this.$router.push(url);
    }
  },
  mounted() {
    // Vue实例渲染完成后执行
    // console.log(this.swi);
    // console.log(this.sp);
  }
};
</script>
<style scoped lang="scss">
@import url("~@/assets/icon/iconfont.css");
@import url("~@/assets/css/tabbar1/tabbar1.css");
.dibu {
  width: 100%;
  margin-bottom: 5px;
  text-align: center;
  color: #999;
  font-size: 0.7rem;
  font-weight: 600;
}
.tab {
  height: 2.4rem;
  width: 100%;
  position: relative;
  bottom: 0px;
}
* {
  color: #666;
}
</style>
